import { Copy, CircleCheckBig, X } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";

const initCopyLabel = (
  <>
    <Copy />
    COPY
  </>
);

export function CopyButton({
  value,
  className,
  suffix="",
  noLabel = false,
  buttonVariant="secondary"
}: {
  value: string;
  className?: string;
  suffix?: string
  noLabel?: boolean;
  buttonVariant?: "secondary" | "ghost",
}) {
  const [copyLabel, setCopyLabel] = useState(noLabel ? <Copy /> : initCopyLabel);
  const doCopy = () => {
    try {
      navigator.clipboard.writeText(value);
      setCopyLabel(
        <>
          <CircleCheckBig />
          { noLabel ? null : <>COPIED</> }
        </>
      );
      setTimeout(() => setCopyLabel(noLabel ? <Copy /> : initCopyLabel), 2500);
    } catch (e) {
      console.error(e);
      setCopyLabel(
        <>
          <X />
          { noLabel ? null : <>ERROR</> }
        </>
      );
      setTimeout(() => setCopyLabel(noLabel ? <Copy /> : initCopyLabel), 2500);
    }
  };
  return (
    <Button
      onClick={doCopy}
      size="sm"
      variant={buttonVariant}
      className={className}
    >
      {copyLabel}{suffix ? <>{' '}{suffix}</> : null}
    </Button>
  );
}
